module.exports = __webpack_public_path__ + "img/forecastBase.18484f8d.png";